<!-- Templates -->
<!-- Skeleton -->
<ng-template #skeletonNonUSF>
  <app-header> </app-header>
  <ion-content>
    <app-list-skeleton></app-list-skeleton>
    <app-footer></app-footer>
  </ion-content>
</ng-template>

<ng-template #addProductsForEmpty let-viewModel="viewModel">
  <!-- Add Products Button -->
  <ion-col data-cy="non-usf-worksheet-add-products-button-column" size="12">
    <div
      data-cy="non-usf-worksheet-add-products-button-section"
      class="non-usf-worksheet-add-products-button"
    >
      <ion-button
        data-cy="non-usf-worksheet-add-products-button"
        class="usf-fill-green-button"
        (click)="openCreateNonUsfProductsModal(viewModel)"
      >
        {{ 'i18n.inventory.nonUsfWorksheet.addProducts' | translate }}
        <ion-icon name="chevron-down" class="create-list-chevron"></ion-icon>
      </ion-button>
    </div>
  </ion-col>
</ng-template>

<ng-template #addPrdouctsForExisting let-viewModel="viewModel">
  <!-- Add Products Button -->
  <ion-col data-cy="non-usf-worksheet-add-products-button-column" size="12">
    <div
      data-cy="non-usf-worksheet-add-products-action-bar-section"
      class="non-usf-worksheet-add-products-action-bar"
      [ngClass]="manageNonUsfProductsService.platformService?.platformType === manageNonUsfProductsService.platformService?.platformEnum?.mobile ? 'mobile-view' : ''"
    >
      <ion-searchbar
        data-cy="non-usf-worksheet-searchbar"
        class="search"
        mode="md"
        placeholder="{{
        'i18n.inventory.searchNonUsfProducts' | translate
      }}"
        [(ngModel)]="searchKey"
        (ionInput)="search()"
        (ionClear)="resetSearch()"
        globalkeyhandler="filterBar"
      ></ion-searchbar>
      <ion-button
        data-cy="non-usf-worksheet-add-products-button"
        class="usf-fill-green-button"
        (click)="openCreateNonUsfProductsModal(viewModel)"
      >
        {{ 'i18n.inventory.nonUsfWorksheet.addProducts' | translate }}
        <ion-icon name="chevron-down" class="create-list-chevron"></ion-icon>
      </ion-button>
    </div>
  </ion-col>
</ng-template>

<!-- Desktop/Tablet Header -->
<ng-template #desktopTabletHeader let-viewModel="viewModel">
  <!-- Breadcrumbs -->
  <ion-row
    *ngIf="(manageNonUsfProductsService.platformService?.isTouchExperience$ | async) === false"
    data-cy="non-usf-worksheet-breadcrumbs-row"
    class="non-usf-header-crumbs"
  >
    <ion-col data-cy="non-usf-worksheet-breadcrumbs-column" size="10">
      <app-back-button
        *ngIf="showBackButton"
        [backButtonText]="'i18n.menuProfitPro.links.recipes'"
      >
      </app-back-button>

      <app-breadcrumbs *ngIf="!showBackButton" [breadcrumbs]="breadcrumbs">
      </app-breadcrumbs>
    </ion-col>
    <ng-container
      *ngIf="viewModel?.totalNonUsfProducts > 0 || viewModel?.showDownloadGlCode"
    >
      <ion-col class="right-align" size="2">
        <div class="download-button" (click)="openDownloadOverlay(viewModel)">
          <ion-icon
            name="download-outline"
            data-cy="inventory-worksheet-download-icon"
          ></ion-icon>
          {{ 'i18n.common.download' | translate }}
        </div>
      </ion-col>
    </ng-container>
  </ion-row>

  <!-- non-usf Info -->
  <ion-row
    data-cy="non-usf-worksheet-header-info-row"
    class="non-usf-header-info"
  >
    <!-- Name, Creation Date -->
    <ion-col data-cy="non-usf-worksheet-header-name-date-column" size="10">
      <ng-container [ngTemplateOutlet]="name"></ng-container>
    </ion-col>
    <ion-col
      *ngIf="(manageNonUsfProductsService.platformService?.isTouchExperience$ | async) === true && (viewModel?.totalNonUsfProducts > 0 || viewModel?.showDownloadGlCode)"
      class="right-align"
      size="2"
    >
      <div class="download-button" (click)="openDownloadOverlay(viewModel)">
        <ion-icon
          name="download-outline"
          data-cy="inventory-worksheet-download-icon"
        ></ion-icon>
        {{ 'i18n.common.download' | translate }}
      </div>
    </ion-col>
  </ion-row>

  <!-- Groups -->
  <ion-row
    data-cy="non-usf-worksheet-header-groups-row"
    class="non-usf-header-groups"
  >
    <ion-col
      data-cy="non-usf-worksheet-header-groups-column"
      class="non-usf-header-group-tabs"
      size="12"
    >
      <div
        data-cy="non-usf-worksheet-groups-tabs"
        class="non-usf-groups-container"
        id="non-usf-groups-container"
      >
        <ng-container
          [ngTemplateOutlet]="groupTabs"
          [ngTemplateOutletContext]="{ viewModel: viewModel }"
        ></ng-container>
      </div>
    </ion-col>
  </ion-row>
</ng-template>

<!-- Mobile Header -->
<ng-template #mobileHeader let-viewModel="viewModel">
  <!-- Name -->
  <ion-row
    data-cy="non-usf-worksheet-header-name-row"
    class="non-usf-header-name-row"
  >
    <ion-col data-cy="non-usf-worksheet-header-name-column">
      <ng-container [ngTemplateOutlet]="name"></ng-container>
    </ion-col>
    <ng-container
      *ngIf="viewModel?.totalNonUsfProducts > 0 || viewModel?.showDownloadGlCode"
    >
      <div data-cy="inventory-banner-ellipsis-section">
        <ion-icon
          data-cy="inventory-banner-ellipsis-icon"
          name="ellipsis-vertical"
          (click)="openDownloadOverlay(viewModel)"
        ></ion-icon>
      </div>
    </ng-container>
  </ion-row>

  <!-- Groups -->
  <ion-row
    data-cy="non-usf-worksheet-header-groups-row"
    class="non-usf-header-groups-row"
  >
    <ion-col
      data-cy="non-usf-worksheet-header-groups-column"
      class="non-usf-header-group-tabs"
      size="12"
    >
      <div class="non-usf-groups-container count-mode">
        <ng-container
          [ngTemplateOutlet]="groupTabs"
          [ngTemplateOutletContext]="{ viewModel: viewModel }"
        ></ng-container>
      </div>
    </ion-col>
  </ion-row>
</ng-template>

<ng-template #groupTabs let-viewModel="viewModel">
  <!-- all tab -->
  <div data-cy="non-usf-worksheet-all-groups-tab" class="selected">
    <div data-cy="non-usf-worksheet-all-groups-text">
      {{ 'i18n.inventory.inventoryWorksheet.all' | translate }}
    </div>
    <ion-badge
      data-cy="non-usf-worksheet-all-groups-icon"
      mode="ios"
      class="group-count"
    >
      {{ viewModel?.totalNonUsfProducts }}
    </ion-badge>
  </div>
  <div class="shadow-cover">&nbsp;</div>
</ng-template>

<ng-template #name>
  <div data-cy="non-usf-worksheet-name-section" class="non-usf-header-name">
    <p data-cy="non-usf-worksheet-name-text">
      {{ 'i18n.inventory.nonUsfWorksheet.pageTitle' | translate }}
    </p>
  </div>
</ng-template>

<ng-container
  *ngIf="nonUsfProductViewModel$ | async as viewModel else skeletonNonUSF"
>
  <app-header> </app-header>

  <ion-content
    id="non-usf-worksheet"
    class="gray-content-bg"
    scroll-y="false"
    [ngClass]="(manageNonUsfProductsService.platformService?.isTouchExperience$ | async) ? manageNonUsfProductsService.platformService?.platformType === manageNonUsfProductsService.platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
  >
    <cdk-virtual-scroll-viewport
      id="non-usf-worksheet-scroll"
      data-cy="inventory-worksheet-scroll"
      class="cdk-scroll"
      orientation="vertical"
      appInvVs
      [itemHeights]="viewModel?.itemHeights"
      [indexOffset]="1"
      [bufferBefore]="20"
      [bufferAfter]="20"
    >
      <div class="non-usf-worksheet-header">
        <ion-grid [fixed]="true">
          <ng-container
            *ngIf="manageNonUsfProductsService.platformService?.platformType !== manageNonUsfProductsService.platformService?.platformEnum?.mobile"
            [ngTemplateOutlet]="desktopTabletHeader"
            [ngTemplateOutletContext]="{ viewModel: viewModel }"
          ></ng-container>
          <ng-container
            *ngIf="manageNonUsfProductsService.platformService?.platformType === manageNonUsfProductsService.platformService?.platformEnum?.mobile"
            [ngTemplateOutlet]="mobileHeader"
            [ngTemplateOutletContext]="{ viewModel: viewModel }"
          ></ng-container>
        </ion-grid>
      </div>
      <ion-grid [fixed]="true">
        <div class="non-usf-worksheet-content">
          <ion-row
            class="empty-state-row"
            data-cy="non-usf-worksheet-empty-state-row"
            *ngIf="viewModel === undefined || (viewModel.products.length === 0 && !searchKey)"
          >
            <ion-col
              data-cy="non-usf-worksheet-empty-state-text-column"
              size="12"
            >
              <div
                data-cy="non-usf-worksheet-empty-state-text-section"
                class="non-usf-worksheet-empty-state-text"
              >
                <span data-cy="non-usf-worksheet-empty-state-text">
                  {{ 'i18n.inventory.nonUsfWorksheet.emptyStateText' | translate
                  }}
                </span>
              </div>
            </ion-col>
            <ng-container
              [ngTemplateOutlet]="addProductsForEmpty"
              [ngTemplateOutletContext]="{viewModel:viewModel}"
            ></ng-container>
          </ion-row>

          <ion-row
            *ngIf="viewModel !== undefined && viewModel.products.length > 0 || (viewModel !== undefined && viewModel.products.length === 0 && searchKey)"
          >
            <app-non-usf-product-import-toast
              *ngIf="manageNonUsfProductsService.importNonUsfProductSuccessToastSubject.value"
              [platform]="manageNonUsfProductsService.platformService.platformType"
              class="import-success-toast"
              (dismissToastEvent)="handleDismissToast()"
              (openNonUsfProductErrorsModalEvent)="openNonUsfProductErrorsModal()"
            ></app-non-usf-product-import-toast>
            <ng-container
              [ngTemplateOutlet]="addPrdouctsForExisting"
              [ngTemplateOutletContext]="{viewModel:viewModel}"
            ></ng-container>
          </ion-row>

          <ion-row
            *ngIf="viewModel.products.length === 0 && !!searchKey"
            class="non-usf-worksheet-no-search-results-row"
          >
            <div
              data-cy="non-usf-worksheet-no-search-results-container"
              class="non-usf-worksheet-no-search-results"
            >
              <span data-cy="non-usf-worksheet-no-search-results-text">
                {{ 'i18n.search.noSearchResults.noResultFound' | translate }}
              </span>
            </div>
          </ion-row>

          <app-non-usf-product-sort-header
            *ngIf="viewModel.products.length > 0"
            [platform]="manageNonUsfProductsService.platformService.platformType"
            [sortOptions]="viewModel.sortOptions"
            (sortClickEmitter)="handleSortClick($event)"
          >
          </app-non-usf-product-sort-header>

          <ion-row>
            <ion-col size="12">
              <app-non-usf-product-card-container
                [productsData]="viewModel.products"
                [platform]="manageNonUsfProductsService.platformService.platformType"
                (selectEvent)="handleSelection($event)"
                (nameClickEvent)="handleNameClick($event, viewModel.vendors)"
              >
              </app-non-usf-product-card-container>
            </ion-col>
          </ion-row>
        </div>
      </ion-grid>
      <app-footer></app-footer>
    </cdk-virtual-scroll-viewport>
  </ion-content>

  <ion-modal
    [isOpen]="manageNonUsfProductsService.deleteProductModalSubject.value"
    (ionModalDidDismiss)="handleDeleteDismiss()"
    [initialBreakpoint]="manageNonUsfProductsService.platformService.platformType !== manageNonUsfProductsService.platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="manageNonUsfProductsService.platformService.platformType !== manageNonUsfProductsService.platformService.platformEnum.desktop  ? [0, 1] : undefined"
    [ngClass]="(manageNonUsfProductsService.platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' :'delete-item-non-usf-modal-desktop'"
  >
    <ng-template>
      <app-delete-items-confirmation-modal
        class="ion-page"
        [platform]="manageNonUsfProductsService.platformService.platformType"
        [isTouch]="manageNonUsfProductsService.platformService?.isTouchExperience$ | async"
        [totalSelected]="totalSelected$ | async"
        [additionalWarning]="'i18n.inventory.inventoryWorksheet.additonalWarningNonUSF'"
        [isWarning]="true"
        [singular]="'i18n.inventory.inventoryWorksheet.deleteInventoryItemsCount2'"
        [plural]="'i18n.inventory.inventoryWorksheet.deleteInventoryItemsCount3'"
        (submitEvent)="handleDeleteSubmit()"
        (dismissEvent)="handleDeleteDismiss()"
      >
      </app-delete-items-confirmation-modal>
    </ng-template>
  </ion-modal>

  <!-- Non USF Product Modal -->
  <ion-modal
    [isOpen]="manageNonUsfProductsService.addnonUsfProductModalSubject.value"
    (ionModalDidDismiss)="manageNonUsfProductsService.openOrCloseNonUsfProductModal(false)"
    [initialBreakpoint]="manageNonUsfProductsService.platformService.platformType !== manageNonUsfProductsService.platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="manageNonUsfProductsService.platformService.platformType !== manageNonUsfProductsService.platformService.platformEnum.desktop  ? [0, 1] : undefined"
    [ngClass]="(manageNonUsfProductsService.platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : pimFlag ? 'modal-desktop-size-xl': 'modal-desktop-size-xl'"
  >
    <ng-template>
      <app-modal-with-nav-inline
        [rootPage]="manageNonUsfProductsService.addProductRootPage"
        [rootPageParams]="manageNonUsfProductsService.addProductParams"
      >
      </app-modal-with-nav-inline>
    </ng-template>
  </ion-modal>

  <ion-modal
    [isOpen]="manageNonUsfProductsService.importProductModalSubject.value"
    [initialBreakpoint]="manageNonUsfProductsService.platformService.platformType !== manageNonUsfProductsService.platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="manageNonUsfProductsService.platformService.platformType !== manageNonUsfProductsService.platformService.platformEnum.desktop  ? [0, 1] : undefined"
    [ngClass]="(manageNonUsfProductsService.platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-xl'"
    (ionModalDidDismiss)="manageNonUsfProductsService.openOrCloseNonUsfImportModal(false)"
  >
    <ng-template>
      <app-modal-with-nav-inline
        [rootPage]="manageNonUsfProductsService.importModalRef"
        [rootPageParams]="manageNonUsfProductsService.importProductParams"
      >
      </app-modal-with-nav-inline>
    </ng-template>
  </ion-modal>

  <!-- Non USF Product Import Errors Modal -->
  <ion-modal
    [isOpen]="manageNonUsfProductsService.importProductErrorsModalSubject.value"
    [initialBreakpoint]="manageNonUsfProductsService.platformService.platformType !== manageNonUsfProductsService.platformService.platformEnum.desktop ? 1 : undefined"
    [breakpoints]="manageNonUsfProductsService.platformService.platformType !== manageNonUsfProductsService.platformService.platformEnum.desktop  ? [0, 1] : undefined"
    [ngClass]="(manageNonUsfProductsService.platformService?.isTouchExperience$ | async) ? 'ion-modal-touch' : 'modal-desktop-size-xl'"
    (ionModalDidDismiss)="manageNonUsfProductsService.openOrCloseNonUsfImportErrorsModal(false)"
  >
    <ng-template>
      <app-import-non-usf-product-errors-modal
        class="ion-page"
        [errorList]="manageNonUsfProductsService.importErrorListSubject"
        [platform]="platformService.platformType"
        [customer]="panAppState.customer$ | async"
        (dismissEvent)="closeImportErrorsModal()"
        (downloadEvent)="downloadImportErrors($event)"
      >
      </app-import-non-usf-product-errors-modal>
    </ng-template>
  </ion-modal>

  <!-- SELECTED PRODUCTS FOOTER TEMPLATE -->
  <!-- DESKTOP AND TABLET -->
  <ng-template #selectedProductsFooter>
    <ion-card
      *ngIf="(totalSelected$ | async) >= 1"
      id="product-selection-footer"
      data-cy="selected-products-footer"
      class="selected-non-usf-worksheet-footer"
    >
      <ng-container
        *ngIf="
      manageNonUsfProductsService.platformService?.platformType === manageNonUsfProductsService.platformService?.platformEnum?.desktop
      "
        class="desktop"
      >
        <div
          data-cy="non-usf-worksheet-selection-section"
          class="non-usf-worksheet-options"
        >
          <ion-text
            data-cy="non-usf-worksheet-num-selected-products-text"
            class="bold-font-weight"
          >
            {{ (totalSelected$ | async) }}&nbsp;{{ ((totalSelected$ | async) > 1
            ? 'i18n.lists.products' : 'i18n.lists.product' ) | translate
            }}&nbsp;{{ 'i18n.lists.selected' | translate }}
          </ion-text>

          <div
            class="separator"
            data-cy="non-usf-worksheet-separator-image"
            src="assets/images/divider-white.svg"
          ></div>
          <div>
            <ion-label
              [hidden]="(totalSelected$ | async) === (nonUsfProductViewModel$ | async).products.length"
              data-cy="select-all"
              class="select-all"
              (click)="handleSelectAllProducts(viewModel.products)"
            >
              {{ 'i18n.lists.selectAll' | translate }}
            </ion-label>
          </div>
          <div
            [hidden]="((totalSelected$ | async) === (nonUsfProductViewModel$ | async).products.length) || ((totalSelected$ | async) < 1) "
            class="separator"
            data-cy="non-usf-worksheet-separator-image"
            src="assets/images/divider-white.svg"
          ></div>
          <div>
            <ion-label
              [hidden]="(totalSelected$ | async) < 1"
              data-cy="deselect-all"
              class="deselect-all"
              (click)="handleDeselectAllProducts()"
            >
              {{ 'i18n.lists.deselectAll' | translate }}
            </ion-label>
          </div>
        </div>
        <div
          data-cy="non-usf-worksheet-actions-section"
          class="non-usf-worksheet-options"
        >
          <ion-label (click)="handleAddToInventory()" data-cy="add-to-inventory"
            >{{ 'i18n.inventory.nonUsfWorksheet.addToInventoryTitle' | translate
            }}
          </ion-label>
          <div
            class="separator"
            data-cy="non-usf-worksheet-separator-image"
            src="assets/images/divider-white.svg"
          ></div>
          <ion-label
            *ngIf="addNonUsfListFlag$ | async"
            (click)="handleAddToList(viewModel)"
            data-cy="add-to-list"
            >{{ 'i18n.lists.addToList' | translate }}
          </ion-label>
          <div
            class="separator"
            data-cy="non-usf-worksheet-separator-image"
            src="assets/images/divider-white.svg"
          ></div>

          <ion-label (click)="handleDelete()" data-cy="delete"
            >{{ 'i18n.inventory.delete' | translate }}
          </ion-label>
        </div>
      </ng-container>
      <!-- Tablet -->
      <div
        *ngIf="
        manageNonUsfProductsService.platformService?.platformType === manageNonUsfProductsService.platformService?.platformEnum?.tablet
      "
        class="tablet-bar"
      >
        <div
          data-cy="non-usf-worksheet-selection-section"
          class="non-usf-worksheet-options"
        >
          <ion-text
            data-cy="non-usf-worksheet-num-selected-products-text"
            class="bold-font-weight"
          >
            {{ (totalSelected$ | async) }}&nbsp;{{ ((totalSelected$ | async) > 1
            ? 'i18n.lists.products' : 'i18n.lists.product' ) | translate
            }}&nbsp;{{ 'i18n.lists.selected' | translate }}
          </ion-text>

          <div
            class="separator"
            data-cy="non-usf-worksheet-separator-image"
            src="assets/images/divider-white.svg"
          ></div>
          <div>
            <ion-label
              [hidden]="(totalSelected$ | async) === (nonUsfProductViewModel$ | async).products.length"
              data-cy="select-all"
              class="select-all"
              (click)="handleSelectAllProducts(viewModel.products)"
            >
              {{ 'i18n.lists.selectAll' | translate }}
            </ion-label>
          </div>
          <div
            [hidden]="((totalSelected$ | async) === (nonUsfProductViewModel$ | async).products.length) || ((totalSelected$ | async) < 1) "
            class="separator"
            data-cy="non-usf-worksheet-separator-image"
            src="assets/images/divider-white.svg"
          ></div>
          <div>
            <ion-label
              [hidden]="(totalSelected$ | async) < 1"
              data-cy="deselect-all"
              class="deselect-all"
              (click)="handleDeselectAllProducts()"
            >
              {{ 'i18n.lists.deselectAll' | translate }}
            </ion-label>
          </div>
        </div>
        <div
          data-cy="non-usf-worksheet-actions-section"
          class="non-usf-worksheet-options"
        >
          <ion-label (click)="handleDelete()" data-cy="delete"
            >{{ 'i18n.inventory.delete' | translate }}
          </ion-label>
          <div
            class="separator"
            data-cy="non-usf-worksheet-separator-image"
            src="assets/images/divider-white.svg"
          ></div>
          <ion-button
            (click)="handleShowAddToInventory()"
            data-cy="add-to-inventory"
            class="usf-fill-white-button"
            >{{ 'i18n.lists.addTo' | translate }}
          </ion-button>
        </div>
      </div>
      <!-- Mobile -->
      <div
        *ngIf="
        manageNonUsfProductsService.platformService?.platformType === manageNonUsfProductsService.platformService?.platformEnum?.mobile
      "
        class="mobile-bar"
      >
        <div
          data-cy="non-usf-worksheet-selection-section"
          class="select-deselect-products-mobile"
        >
          <ion-text
            [hidden]="(totalSelected$ | async) === (nonUsfProductViewModel$ | async).products.length"
            data-cy="select-all"
            class="bold-font-weight"
            (click)="handleSelectAllProducts(viewModel.products)"
          >
            {{ 'i18n.lists.selectAll' | translate }}
          </ion-text>
          <ion-text
            [hidden]="(totalSelected$ | async) < 1"
            data-cy="deselect-all"
            (click)="handleDeselectAllProducts()"
          >
            {{ 'i18n.lists.deselectAll' | translate }}
          </ion-text>
        </div>
        <ion-button
          (click)="handleShowAddToInventory()"
          data-cy="add-to-inventory"
          class="usf-outline-green-button"
          >{{ (totalSelected$ | async) }}&nbsp;{{ 'i18n.lists.selected' |
          translate }}
          <ion-icon
            data-cy="non-usf-worksheet-action-ellipsis-icon"
            class="selected-products-ellipsis"
            name="ellipsis-vertical"
          ></ion-icon>
        </ion-button>
      </div>
    </ion-card>
  </ng-template>

  <!-- Selected Products Footer -->
  <ng-container
    [ngTemplateOutlet]="selectedProductsFooter"
    [ngTemplateOutletContext]="{ viewModel: viewModel }"
  ></ng-container>

  <!-- Add to List Modal -->
  <ion-modal
    [isOpen]="this.addToListModalService.isModalOpen$ | async"
    (ionModalDidDismiss)="this.addToListModalService.closeModal()"
    [class]="
      (platformService?.isTouchExperience$ | async)
        ? 'ion-modal-touch'
        : 'modal-desktop-size-xl'
    "
    [initialBreakpoint]="
      platformService?.platformType !== platformService?.platformEnum.desktop
        ? 1
        : undefined
    "
    [breakpoints]="
      platformService?.platformType !== platformService?.platformEnum.desktop
        ? [0, 1]
        : undefined
    "
    id="addToListModal"
  >
    <ng-template>
      <app-modal-with-nav-inline
        [rootPage]="this.addToListModalService.dualPaneRef"
        [rootPageParams]="this.addToListModalService.dualPaneModalData"
      >
      </app-modal-with-nav-inline>
    </ng-template>
  </ion-modal>
</ng-container>
